import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { IonHeader, IonToolbar, IonTitle, IonRouterOutlet, IonIcon, IonButton, IonButtons } from '@ionic/angular/standalone';
import { SidebarComponent } from './sidebar.component';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonRouterOutlet,
    RouterModule,
    SidebarComponent,
    IonIcon,
    IonButton,
    IonButtons
  ],
  template: `
    <div class="app-shell">
      <app-sidebar [currentUserRole]="currentUserRole"></app-sidebar>
      <div class="main-content">
        <ion-header>
          <ion-toolbar color="primary">
            <ion-title>Piled Admin Portal</ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="onLogout()" fill="clear" color="light">
                <ion-icon slot="icon-only" name="log-out-outline" style="font-size: 24px;"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-router-outlet></ion-router-outlet>
      </div>
    </div>
  `,
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit, OnDestroy {
  currentUserRole: string | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService, 
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadUserInfo();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private loadUserInfo() {
    const sub = this.userService.getCurrentUser().subscribe({
      next: (response: any) => {
        const userData = response.data || response;
        if (userData && userData.role) {
          this.currentUserRole = userData.role;
        }
      },
      error: (error: any) => {
        console.error('Error loading user info:', error);
        this.currentUserRole = null;
      }
    });
    this.subscriptions.push(sub);
  }

  onLogout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
} 